import { useState } from 'react';
import { Link, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Input, Modal, Skeleton } from '@koyomi/ui';
import { screenFor, useHelpScreen, useHelpSearch } from './help-api.ts';
import { FaqList, TutorialList } from './HelpPage.tsx';
import './help.css';

/**
 * Botão "?" fixo: abre a Ajuda da tela atual (itens marcados com ela no Admin) e o atalho para a Central.
 * Com 2 letras ou mais na busca, mostra resultados de toda a Central, não só desta tela.
 */
export function HelpButton({ wizardOpen }: { wizardOpen: boolean }) {
  const { t } = useTranslation(['common']);
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const screen = screenFor(pathname, wizardOpen);
  const searching = q.trim().length >= 2;
  const byScreen = useHelpScreen(screen, open && !searching);
  const search = useHelpSearch(open ? q : '');
  if (pathname.startsWith('/ajuda')) return null;
  const close = () => { setOpen(false); setQ(''); };
  const src = searching ? search : byScreen;
  const data = src.data;
  const empty = data && !data.faqs.length && !data.tutorials.length;
  return (
    <>
      <button type="button" className="help-fab" aria-label={t('common:help.button')} title={t('common:help.button')} onClick={() => setOpen(true)}>?</button>
      <Modal open={open} onClose={close} title={t('common:help.thisScreen')} footer={<Link className="k-btn k-btn--primary" to="/ajuda" onClick={close}>{t('common:help.openCenter')}</Link>}>
        <div className="k-stack" style={{ gap: 14 }}>
          <Input type="search" aria-label={t('common:help.search')} placeholder={t('common:help.searchPlaceholder')} value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
          {!searching && !screen ? <p className="k-muted" style={{ margin: 0 }}>{t('common:help.nothingHere')}</p>
            : src.isError || empty ? <p className="k-muted" style={{ margin: 0 }}>{searching ? t('common:help.noResults') : t('common:help.nothingHere')}</p>
            : !data ? <Skeleton lines={4} />
            : (
              <div className="k-stack" style={{ gap: 16 }}>
                {searching && <span className="k-muted" style={{ fontSize: 12 }}>{t('common:help.searchAll')}</span>}
                {data.faqs.length > 0 && <FaqList faqs={data.faqs} onNavigate={close} />}
                {data.tutorials.length > 0 && <TutorialList tutorials={data.tutorials} onNavigate={close} />}
              </div>
            )}
        </div>
      </Modal>
    </>
  );
}
